import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-parent" }
const _hoisted_2 = { class: "search-place" }
const _hoisted_3 = { class: "command-panel" }
const _hoisted_4 = { class: "labels-place" }
const _hoisted_5 = { class: "total-label" }
const _hoisted_6 = {
  key: 0,
  class: "selected-label"
}
const _hoisted_7 = { class: "quick-filters-place" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Site Admin")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Clinician")
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_11 = { class: "table-parent" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_13 = { class: "paging-place" }
const _hoisted_14 = { class: "paging-label" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Showing ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" from ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" data ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_TableHeaderComponent = _resolveComponent("TableHeaderComponent")
  const _component_StatusRectangle = _resolveComponent("StatusRectangle")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_SearchInput, {
        modelValue: _ctx.state.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.search = $event)),
        "debounce-time": 500,
        onDebounceInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchChanged()))
      }, null, 8, ["modelValue"]),
      _createVNode("button", {
        class: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addUser()))
      }, "+ Add user")
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, "Total: " + _toDisplayString(_ctx.state.paging.total), 1),
        (_ctx.list.selected.length)
          ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.list.selected.length) + " selected ", 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_el_checkbox_group, {
          class: "quick-filters",
          modelValue: _ctx.state.filtersData.roles.values,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.filtersData.roles.values = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox, {
              label: _ctx.UserRole.SiteAdmin
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_checkbox, {
              label: _ctx.UserRole.Clinician
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dropdown, {
          type: "primary",
          trigger: "click",
          disabled: !_ctx.currentBulkOperations.length
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentBulkOperations, (operation) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    class: { 'delemiter-after': operation.delemiterAfter },
                    key: operation.action,
                    onClick: ($event: any) => (_ctx.handleBulkAction(operation.action, _ctx.list.selected))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(operation.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              disabled: !_ctx.currentBulkOperations.length
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _withDirectives(_createVNode(_component_el_table, {
        class: "list-table",
        ref: "multipleTable",
        data: _ctx.list.data,
        style: {"width":"100%"},
        "header-row-class-name": "header-row",
        stripe: true,
        "select-on-indeterminate": false,
        "empty-text": "Nothing is found. Please change your search parameters",
        onSelectionChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectionChange($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            fixed: ""
          }),
          _createVNode(_component_el_table_column, {
            label: "Name",
            "min-width": "150",
            fixed: ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Name',
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.userFirstName),
                onChangeSorting: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.userFirstName, $event)))
              }, null, 8, ["sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createVNode("a", {
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.viewUser(scope.row)), ["prevent"])
              }, _toDisplayString(scope.row.first_name) + " " + _toDisplayString(scope.row.last_name), 9, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Role",
            width: "170"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Role',
                filterable: true,
                filterData: _ctx.state.filtersData.roles,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.roles),
                onChangeSorting: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.roles, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.formatUserRoles(scope.row.role_ids)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            property: "email",
            label: "Email",
            "min-width": "240"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Email',
                sortable: false
              })
            ]),
            default: _withCtx((scope) => [
              _createVNode("a", {
                href: `mailto:${scope.row.email}`
              }, _toDisplayString(scope.row.email), 9, ["href"])
            ]),
            _: 1
          }),
          (_ctx.hasRole(_ctx.UserRole.SystemAdmin))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                property: "site_name",
                label: "Site",
                "min-width": "240"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_TableHeaderComponent, {
                    header: 'Site',
                    filterable: true,
                    filterData: _ctx.state.filtersData.sites,
                    sortable: true,
                    sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.siteName),
                    onChangeSorting: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.siteName, $event)))
                  }, null, 8, ["filterData", "sortingValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            "class-name": "status-cell",
            label: "Status",
            width: "140"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_TableHeaderComponent, {
                header: 'Status',
                filterable: true,
                filterData: _ctx.state.filtersData.statuses,
                sortable: true,
                sortingValue: _ctx.getSortingValueForField(_ctx.fieldNames.status),
                onChangeSorting: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sortingChange(_ctx.fieldNames.status, $event)))
              }, null, 8, ["filterData", "sortingValue"])
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_StatusRectangle, {
                status: scope.row.user_status
              }, null, 8, ["status"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            "class-name": "actions-cell",
            label: "Actions",
            fixed: "right",
            width: "83"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, {
                type: "primary",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.operationForStatus(
                      scope.row.user_status
                    ), (operation) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          class: { 'delemiter-after': operation.delemiterAfter },
                          key: operation.action,
                          onClick: ($event: any) => (_ctx.handleAction(operation.action, scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(operation.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    disable: _ctx.operationForStatus(scope.row.user_status).length
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["disable"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, _ctx.state.isLoading]
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("span", null, _toDisplayString(_ctx.list.data.length), 1),
          _hoisted_16,
          _createVNode("span", null, _toDisplayString(_ctx.state.paging.total), 1),
          _hoisted_17
        ]),
        (_ctx.state.paging.total > _ctx.state.paging.pageSize)
          ? (_openBlock(), _createBlock(_component_el_pagination, {
              key: 0,
              class: "table-paging",
              layout: "prev, pager, next",
              "current-page": _ctx.state.paging.page,
              "page-size": _ctx.state.paging.pageSize,
              "pager-count": 5,
              total: _ctx.state.paging.total,
              onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pageChange($event)))
            }, null, 8, ["current-page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}